/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
import React, { useCallback, useContext, useEffect, useState } from "react";
// import DataTable from "../../components/Layout/Table/DataTable";
import {
  Box,
  TableCell,
  TableRow,
  Typography,
  Autocomplete,
  TextField,
  Tooltip,
} from "@mui/material";
import * as Sentry from "@sentry/react";
import moment from "moment";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import UploadIcon from "@mui/icons-material/Upload";
import styled from "styled-components";
import DownloadIcon from "@mui/icons-material/Download";
import { useDispatch, useSelector } from "react-redux";
import CachedIcon from "@mui/icons-material/Cached";
// import { Autocomplete, TextField } from "@mui/material";
import { transform } from "lodash";
import { Helmet } from "react-helmet";
import { OuterContainerStyles } from "../../components/Layout/Typography";
import Heading from "../../components/Layout/Heading";
import PageSyncCal from "../../components/Layout/PageSyncCal";
import AutoCompleteDropdown from "../../components/Layout/AutoCompleteDropdown/AutoCompleteDropdown";
import { SERVICES } from "../../components/Layout/Services";
import { get, post } from "../../components/Layout/ApiHandler/apihandler";
import InputField from "../../components/Layout/fieldInput/InputField";
import OrganizationStructure from "../Reports/Components/OrganizationStructureNew/OrganizationStructure";
import OrganizationStructureChapterLevel from "../../components/Layout/OrganizationStructure/OrganizationStructureChapterLevel";
import BasicDatePicker from "../../components/DatePicker/BasicDatePickerV2";
import Button from "../../components/Layout/Button";
import { ToastAlertContext } from "../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../contants";
import NewTable from "../PendingOnlineContribution/Components/NewTable/NewTable";
import Pagination from "../../components/Layout/Pagination";
import UploadReceiptModal from "./Components/UploadReceiptModal";
import EditBankDepositModal from "./Components/EditBankDepositModal";
import Loader from "../../components/Loader/Loader";
import { logoutAction } from "../../Config/Redux/actions/authActions";
import DateRangePicker from "../Reports/Components/DateRangePicker/DateRangePicker";
import DownloadReceiptModal from "./Components/DownloadReceiptModal";
import NewPopover from "../Member/Components/Popover/NewPopover";
import AppliedFilter from "./Components/AppliedFilter/AppliedFilter";
import OrganizationStructureForAdmin from "./Components/OrganizationStructure";
import styles from "./BankDepositDetails.styles";

// import Typography from "../../../components/Typography/Typography";

const DEFAULT_PAGE_SIZE = 10;
const getOptions = (options, key) =>
  options?.map((opt) => ({
    ...opt,
    value: opt[key],
  }));
const initialFormValues = {
  areaId: null,
  zoneId: null,
  regionId: null,
  chapterId: null,
};
const BANK_DEPOSIT_DETAILS_COL = [
  {
    displayName: "S.No",
  },
  {
    displayName: "Bank Name",
  },
  {
    displayName: "Org Structure",
  },
  // {
  //   displayName: "Status",
  // },
  {
    displayName: "Deposited At",
  },
  {
    displayName: "Date From",
  },
  {
    displayName: "Date To",
  },
  {
    displayName: "Amount",
  },
  {
    displayName: "Actions",
  },
];
const initialFormValue = {
  // fromDate: new Date(),
  // toDate: new Date(),
  fromDate: new Date("2025-11-09"), // 9 November 2025
  toDate: new Date("2025-11-09"), // 9 November 2025
};

function BankDepositDetails() {
  // const memberId = localStorage.getItem("memberId");
  const TITLE = "Add Bank Deposit  Details - BSG ContributionAdmin";
  const [bankTypes, setBankTypes] = useState([]);
  const [selectedBankType, setSelectedBankType] = useState("");
  const [selectedBankName, setSelectedBankName] = useState("");
  const [cashTotal, setCashTotal] = useState(null);
  const [chequeAmountValueSameBank, setChequeAmountValueSameBank] =
    useState(null);
  const [chequeAmountValueDifferentBank, setChequeAmountValueDifferentBank] =
    useState(null);
  const [ddTotal, setDDTotal] = useState(null);
  const [total, setTotal] = useState(null);
  const [ddAmountValue, setDDAmountValue] = useState("");
  const [memberId, setMemberId] = useState("");
  const [debouncedMemberId, setDebouncedMemberId] = useState(memberId);
  const [selectedMember, setSelectedMember] = useState(null);
  const [members, setMembers] = useState([]);
  const [clearContributions, setClearContributions] = useState(false);
  const [searchPerformed, setSearchPerformed] = useState(false);
  const [values, setValues] = useState({
    areaId: initialFormValues.areaId,
    zoneId: initialFormValues.zoneId,
    regionId: initialFormValues.regionId,
    chapterId: initialFormValues.chapterId,
  });
  const [valuesAdmin, setValuesAdmin] = useState({
    areaId: null,
    zoneId: null,
    regionId: null,
    chapterId: null,
  });

  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [selectedDepositDate, setSelectedDepositDate] = useState(null);
  const [selectedToDate, setSelectedToDate] = useState(null);
  const [bankData, setBankData] = useState({});
  const [tableData, setTableData] = useState([]);
  const toast = useContext(ToastAlertContext);
  const [currentPage, setCurrentPage] = useState(0);
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [uploadId, setUploadId] = useState(null);
  const [editId, setEditId] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [profileData, setProfileData] = useState({});
  const [clearValues, setClearValues] = useState(false);
  const [chapterContributionCycle, setChapterContributionCycle] =
    useState(null);
  const [initialAdvanceFormValue, setInitialAdvanceFormValue] =
    useState(initialFormValue);

  const SelectedUser = useSelector((state) => state.user);
  // console.log(
  //   "Redux store full state:",
  //   useSelector((state) => state)
  // );

  const [orgNames, setOrgNames] = useState({
    areaName: null,
    zoneName: null,
    regionName: null,
    chapterName: null,
    districtName: null,
    blockName: null,
  });
  const [appliedFilters, setAppliedFilters] = useState([]);

  const renderAppliedFilter = (paramKey, displayName, value, onRemove) => {
    return (
      orgNames && (
        <AppliedFilter
          filter={{
            displayName,
            value,
          }}
          onRemove={onRemove}
        />
      )
    );
  };

  // const filters = [
  //   orgNames.areaName &&
  //     renderAppliedFilter("areaId", "Area", orgNames.areaName),
  //   orgNames.zoneName &&
  //     renderAppliedFilter("zoneId", "Zone", orgNames.zoneName),
  //   orgNames.regionName &&
  //     renderAppliedFilter("regionId", "Region", orgNames.regionName),
  //   orgNames.chapterName &&
  //     renderAppliedFilter("chapterId", "Chapter", orgNames.chapterName),
  // ].filter(Boolean);
  const handleAmountChange = (value) => {
    setCashTotal(value);
  };
  const handleChequeAmountSameChange = (value) => {
    setChequeAmountValueSameBank(value);
  };
  const handleChequeAmountDiffChange = (value) => {
    setChequeAmountValueDifferentBank(value);
  };
  const handleDDAmountChange = (value) => {
    setDDTotal(value);
  };
  const handleTotalAmount = (value) => {
    setTotal(value);
  };
  // const handleMemberId = (value) => {
  //   setMemberId(value);
  //   setMemberDetails(value);
  // };
  const handleUpdateModal = () => {
    setUpdateModalOpen(false);
  };
  const handleDownloadModal = () => {
    setDownloadModalOpen(false);
  };
  const handleUplaodReceiptModal = (id) => {
    setUploadId(id);
    setUpdateModalOpen(true);
  };
  const handleDownloadReceiptModal = (id) => {
    setUploadId(id);
    setDownloadModalOpen(true);
  };
  const handleEditModal = (id, paymentOrderFrom, paymentOrderTo) => {
    setEditId(id);
    setFromDate(paymentOrderFrom);
    setToDate(paymentOrderTo);
    setEditModalOpen(true);
  };
  const updateOrganizationStructureValues = (updatedValues) => {
    setValues(updatedValues);
  };
  const updateOrganizationStructureValuesAdmin = (updatedValues) => {
    setValuesAdmin(updatedValues);
  };
  const handleFromDateChange = (date) => {
    const formattedDate = moment(date.$d).format("YYYY-MM-DDTHH:mm:ss");
    setSelectedFromDate(formattedDate);
  };
  const handleDepositDateChange = (date) => {
    const formattedDate = moment(date.$d).format("YYYY-MM-DDTHH:mm:ss");
    setSelectedDepositDate(formattedDate);
  };
  const handleToDateChange = (date) => {
    const formattedDate = moment(date.$d).format("YYYY-MM-DDTHH:mm:ss");
    setSelectedToDate(formattedDate);
  };

  function formatDateToYYYYMMDD(date) {
    return moment(date).format("YYYY-MM-DDTHH:mm:ss");
  }
  const getUserRole = async () => {
    try {
      const url = `${SERVICES.GET_PROFILE}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setProfileData(data.data);
      } else {
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const getChapterContributionCycle = async () => {
    setIsLoading(true);
    const formattedStartDate = formatDateToYYYYMMDD(
      initialAdvanceFormValue.fromDate,
    );
    const formattedEndDate = formatDateToYYYYMMDD(
      initialAdvanceFormValue.toDate,
    );
    try {
      console.log("chapterId:", SelectedUser?.adminData?.chapterId);
      console.log("paymentOrderFrom:", formattedStartDate);
      console.log("paymentOrderTo:", formattedEndDate);
      const url = `${SERVICES.CHAPTER_CONTRIBUTION_CYCLE}/${SelectedUser?.adminData?.chapterId}?paymentOrderFrom=${formattedStartDate}&paymentOrderTo=${formattedEndDate}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        // setProfileData(data.data);
        if (
          data?.message === "Contribution Cycle fetched successfully" &&
          data?.data
        ) {
          setChapterContributionCycle(data.data);
          setSelectedBankType(data.data.defaultDepositBankId);
          setCashTotal(data.data.cashTotal);
          setDDTotal(data.data.ddTotal);
          setTotal(data.data.total);
          setChequeAmountValueSameBank(data.data.chequeTotalSameBank);
          setChequeAmountValueDifferentBank(data.data.chequeTotalDifferentBank);
        }
        setIsLoading(false);
      } else {
        console.error("Failed to fetch Division Type data");
        setIsLoading(false);
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    }
  };
  const handleBankTypes = async () => {
    try {
      // const url = `${SERVICES.GET_BSG_BANKS}`;
      const url = `${SERVICES.BANKS_DETAILS}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        const bankList = data?.data?.content;
        setBankTypes(bankList);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const validateBankDetails = () => {
    if (!selectedBankType) {
      toast.show("Please Select Bank", AlertStatus.ERROR);
      return false;
    }
    if (!memberId) {
      toast.show("Please Enter MemberId", AlertStatus.ERROR);
      return false;
    }
    if (!selectedDepositDate) {
      toast.show("Please Select Deposit Date", AlertStatus.ERROR);
      return false;
    }
    if (total === (0 || null)) {
      toast.show("Total amount cannot be zero", AlertStatus.ERROR);
      return false;
    }
    // if (!selectedFromDate) {
    //   toast.show("Please Select From Date", AlertStatus.ERROR);
    //   return false;
    // }
    // if (!selectedToDate) {
    //   toast.show("Please Select To Date", AlertStatus.ERROR);
    //   return false;
    // }
    return true;
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    if (!validateBankDetails()) {
      setIsLoading(false);
      return;
    }
    const formattedStartDate = formatDateToYYYYMMDD(
      initialAdvanceFormValue.fromDate,
    );
    const formattedEndDate = formatDateToYYYYMMDD(
      initialAdvanceFormValue.toDate,
    );
    // const formattedDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSS");
    const extractedMemberId = memberId ? memberId.split(" - ")[0] : null;
    const data = {
      bankName: selectedBankName,
      areaId: values.areaId,
      zoneId: values.zoneId,
      regionId: values.regionId,
      chapterId: values.chapterId,
      bankId: selectedBankType,
      status: "DEPOSITED",
      depositedAt: selectedDepositDate,
      depositedBy: extractedMemberId,
      paymentOrderFrom: formattedStartDate,
      paymentOrderTo: formattedEndDate,
      amount: Number(cashTotal),
    };
    const url = `${SERVICES.OFFLINE_BANK_DEPOSIT}`;
    try {
      const response = await post(url, data);
      if (response.ok) {
        const res = await response.json();
        toast.show("Details Added Successfully", AlertStatus.SUCCESS);
        await getBankDetails();
        resetForm();
        setIsLoading(false);
      } else {
        const errorData = await response.json();
        toast.show(errorData.message, AlertStatus.ERROR);
        setIsLoading(false);
      }
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
      setIsLoading(false);
    }
  };
  const getBankDetails = async () => {
    setIsLoading(true);
    const url = `${SERVICES.OFFLINE_BANK_DEPOSIT}`;
    try {
      const response = await get(url);
      if (response.ok) {
        const res = await response.json();
        setBankData(res?.data);
        setTableData(res?.data?.content);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    } finally {
      // setIsLoading(false);
    }
  };
  const pageCount = bankData.totalPages;
  const getRows = (data) =>
    data.map((contInfo, index) => {
      const serialNumber = currentPage * DEFAULT_PAGE_SIZE + index + 1;
      return (
        <TableRow key={contInfo.id}>
          <TableCell>{serialNumber}</TableCell>
          <TableCell>{contInfo?.bankName}</TableCell>
          <TableCell sx={{ maxWidth: "10rem" }}>{`${
            contInfo?.areaName ?? "-"
          }/${contInfo?.zoneName ?? "-"}/${contInfo?.regionName ?? "-"}/${
            contInfo?.chapterName ?? "-"
          }`}</TableCell>
          <TableCell>
            {moment(contInfo?.depositedAt).format("YYYY-MM-DD")}
          </TableCell>
          <TableCell>
            {moment(contInfo?.paymentOrderFrom).format("YYYY-MM-DD")}
          </TableCell>
          <TableCell>
            {moment(contInfo?.paymentOrderTo).format("YYYY-MM-DD")}
          </TableCell>
          <TableCell>{contInfo?.amount}</TableCell>
          <TableCell>
            <Box sx={{ display: "flex", gap: "10px", justifyContent: "left" }}>
              <Tooltip title="View Details" placement="top">
                <VisibilityIcon
                  onClick={() =>
                    handleEditModal(
                      contInfo?.id,
                      contInfo?.paymentOrderFrom,
                      contInfo?.paymentOrderTo,
                    )
                  }
                  style={{
                    cursor: "pointer",
                    height: "16px",
                    width: "16px",
                    color: "#484848",
                  }}
                />
              </Tooltip>
              {profileData?.assignedRoles?.includes(
                "contributionOfflineDataEntry",
              ) && (
                <Tooltip title="Upload Deposit Slips" placement="top">
                  <UploadIcon
                    onClick={() => handleUplaodReceiptModal(contInfo?.id)}
                    style={{
                      cursor: "pointer",
                      height: "16px",
                      width: "16px",
                      color: "#484848",
                    }}
                  />
                </Tooltip>
              )}
              {/* {contInfo?.depositS3Key !== null && (
                <DownloadIcon
                  onClick={() => handleDownloadReceiptModal(contInfo?.id)}
                  style={{
                    cursor: "pointer",
                    height: "16px",
                    width: "16px",
                    color: "#484848",
                  }}
                />
              )} */}
              <Tooltip title="Download or View Deposit Slips" placement="top">
                <DownloadIcon
                  onClick={() => handleDownloadReceiptModal(contInfo?.id)}
                  style={{
                    cursor: "pointer",
                    height: "16px",
                    width: "16px",
                    color: "#484848",
                  }}
                />
              </Tooltip>
            </Box>
          </TableCell>
        </TableRow>
      );
    });
  const handleChangePage = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
    handlePageChange(selectedPage.selected);
  };
  // const handlePageChange = async (selectedPage) => {
  //   setIsLoading(true);
  //   setCurrentPage(selectedPage);
  //   try {
  //     const url = `${
  //       SERVICES.OFFLINE_BANK_DEPOSIT
  //     }?pageNumber=${selectedPage}&pageSize=${10}`;
  //     const response = await get(url);

  //     if (response && response.ok) {
  //       const data = await response.json();
  //       setTableData(data?.data?.content);
  //     } else {
  //       console.error("Failed to fetch contribution data");
  //       setIsLoading(false);
  //     }
  //   } catch (error) {
  //     Sentry.captureException(error);
  //     setIsLoading(false);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };
  const handlePageChange = async (selectedPage) => {
    setIsLoading(true);
    setCurrentPage(selectedPage);

    const { areaId, zoneId, regionId, chapterId } = valuesAdmin;

    let url = `${SERVICES.OFFLINE_BANK_DEPOSIT}?pageNumber=${selectedPage}&pageSize=10`;

    if (areaId || zoneId || regionId || chapterId) {
      const queryParams = [];
      if (areaId) queryParams.push(`areaId=${areaId}`);
      if (zoneId) queryParams.push(`zoneId=${zoneId}`);
      if (regionId) queryParams.push(`regionId=${regionId}`);
      if (chapterId) queryParams.push(`chapterId=${chapterId}`);

      url += `&${queryParams.join("&")}`;
    }

    try {
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        setTableData(data?.data?.content);
        setIsLoading(false);
      } else {
        console.error("Failed to fetch contribution data");
        setIsLoading(false);
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    } finally {
      // setIsLoading(false);
    }
  };
  // const downloadReceipt = async (downloadInfoId) => {
  //   try {
  //     const url = `${SERVICES.OFFLINE_BANK_DEPOSIT}/${downloadInfoId}/bankDepositReceipt`;
  //     const response = await get(url);
  //     if (response.ok) {
  //       const data = await response.json();
  //       // console.log("Line 122", data);
  //       window.open(data?.data, "_blank");
  //     } else {
  //       console.error("API Error:", response);
  //     }
  //   } catch (error) {
  //     Sentry.captureException(error);
  //   }
  // };
  const resetForm = () => {
    // setAmountValue("");
    setMemberId("");
    // setClearValues(true);
    // setSelectedFromDate(null);
    // setSelectedToDate(null);
    setSelectedDepositDate(null);
    // setSelectedBankType("");
  };
  useEffect(() => {
    handleBankTypes();
    getBankDetails();
    getUserRole();
    // getChapterContributionCycle();
  }, []);
  useEffect(() => {
    if (SelectedUser?.adminData?.chapterId) {
      getChapterContributionCycle();
    }
  }, [SelectedUser?.adminData?.chapterId]);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedMemberId(memberId);
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [memberId]);
  const getMemberDeatils = async () => {
    const numericMemberId =
      debouncedMemberId.match(/\d+/)?.[0] || debouncedMemberId;
    try {
      const url = `${SERVICES.GET_MEMBER_SEARCH}?inOrganisationStructure=true&memberId=${numericMemberId}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        setMembers(data?.data?.content);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  useEffect(() => {
    if (debouncedMemberId) {
      getMemberDeatils();
    }
  }, [debouncedMemberId]);

  const getBankDetailsForAdmin = async () => {
    setIsLoading(true);
    setSearchPerformed(true);
    const newFilters = [
      orgNames.areaName &&
        renderAppliedFilter("areaId", "Area", orgNames.areaName),
      orgNames.zoneName &&
        renderAppliedFilter("zoneId", "Zone", orgNames.zoneName),
      orgNames.regionName &&
        renderAppliedFilter("regionId", "Region", orgNames.regionName),
      orgNames.chapterName &&
        renderAppliedFilter("chapterId", "Chapter", orgNames.chapterName),
    ].filter(Boolean);

    setAppliedFilters(newFilters);

    const { areaId, zoneId, regionId, chapterId } = valuesAdmin;

    let url = `${SERVICES.OFFLINE_BANK_DEPOSIT}`;

    if (areaId || zoneId || regionId || chapterId) {
      const queryParams = [];
      if (areaId) queryParams.push(`areaId=${areaId}`);
      if (zoneId) queryParams.push(`zoneId=${zoneId}`);
      if (regionId) queryParams.push(`regionId=${regionId}`);
      if (chapterId) queryParams.push(`chapterId=${chapterId}`);

      url += `?${queryParams.join("&")}`;
    }

    try {
      const response = await get(url);
      if (response.ok) {
        const res = await response.json();
        setBankData(res?.data);
        setTableData(res?.data?.content);
        setIsLoading(false);
      }
      setIsLoading(false);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
      setIsLoading(false);
    } finally {
      // setIsLoading(false);
    }
  };
  const removeFilter = () => {
    setClearContributions(true);
    setOrgNames({
      areaName: "",
      zoneName: "",
      regionName: "",
      chapterName: "",
      districtName: "",
      blockName: "",
    });
    setTimeout(() => {
      setClearContributions(false);
      setSearchPerformed(false);
    }, 100);
  };
  return (
    <div style={{ width: "100%", overflow: "hidden" }}>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <PageSyncCal />
      {profileData?.assignedRoles?.includes("contributionOfflineDataEntry") ? (
        <Heading title="Add Bank Deposit  Details" />
      ) : (
        <Heading title="Bank Deposit  Details" />
      )}
      <OuterContainerStyles marginTop="24px" style={{ padding: "24px" }}>
        {profileData?.assignedRoles?.includes(
          "contributionOfflineDataEntry",
        ) && (
          <Box>
            <Box sx={{ padding: "12px 24px", marginTop: "10px" }}>
              <Typography>Org Structure</Typography>
              <OrganizationStructureChapterLevel
                onUpdateValues={updateOrganizationStructureValues}
                clearValues={clearValues}
                initialAreaId={SelectedUser?.adminData?.areaId}
                initialZoneId={SelectedUser?.adminData?.zoneId}
                initialRegionId={SelectedUser?.adminData?.regionId}
                initialChapterId={SelectedUser?.adminData?.chapterId}
                disabled
              />
            </Box>
            <Box sx={{ display: "flex", gap: "20px", alignItems: "center" }}>
              <Box sx={{ width: "30%", paddingLeft: "24px" }}>
                <DateRangePicker
                  label="Contribution Date"
                  name="date"
                  startDateVal={initialAdvanceFormValue.fromDate}
                  endDateVal={initialAdvanceFormValue.toDate}
                  onChange={(startDate, endDate) => {
                    setInitialAdvanceFormValue({
                      ...initialAdvanceFormValue,
                      fromDate: startDate,
                      toDate: endDate,
                    });
                  }}
                />
              </Box>
              <Button
                variant="contained"
                onClick={() => getChapterContributionCycle()}
                sx={{
                  backgroundColor: "#1D7196",
                  color: "white",
                  textTransform: "none",
                  fontSize: "13px",
                  fontWeight: 500,
                  borderRadius: "6px",
                  padding: "5px 12px",
                  "&:hover": {
                    backgroundColor: "#155a78",
                  },
                }}
              >
                Refresh
              </Button>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                // gap: "10px",
                // alignItems: "center",
                paddingLeft: "24px",
                paddingTop: "10px",
              }}
            >
              <Typography sx={{ color: "Red" }}>
                Steps to upload deposit slips:
              </Typography>
              <Typography sx={{ color: "Red" }}>
                1.{" "}
                <span style={{ fontWeight: "bold" }}>
                  Select "Contribution Date"
                </span>{" "}
                - Carefully choose the exact date the contributions were made.
              </Typography>
              <Typography sx={{ color: "Red" }}>
                2. Press the{" "}
                <span style={{ fontWeight: "bold" }}>"Refresh" Button</span>{" "}
                located next to the "Contribution Date" field. This will update
                all figures on the form.
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                padding: "12px 24px",
                alignItems: "center",
                gap: "146px",
                alignSelf: "stretch",
                marginTop: "20px",
              }}
            >
              <AutoCompleteDropdown
                getOptionLabel={(option) => option.bankName}
                options={getOptions(bankTypes, "id")}
                label="Deposit Bank"
                name="paymentMethods"
                value={selectedBankType}
                onChange={(selectedValue) => {
                  setSelectedBankType(selectedValue?.value);
                  setSelectedBankName(selectedValue?.bankName);
                }}
                inputProps={{ required: true }}
                useHiddenInput
                style={{ width: "350px" }}
                disabled
              />
              <InputField
                label="Cash Deposit Total"
                name="amount"
                required
                value={cashTotal ?? 0}
                onChange={(event) => {
                  const { value } = event.target;
                  handleAmountChange(value);
                }}
                disabled
                style={{ width: "350px" }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                padding: "12px 24px",
                alignItems: "center",
                gap: "146px",
                alignSelf: "stretch",
              }}
            >
              <InputField
                label="Total Cheque/DD Amount (Same Bank)"
                name="amount"
                required
                value={chequeAmountValueSameBank ?? 0}
                onChange={(event) => {
                  const { value } = event.target;
                  handleChequeAmountSameChange(value);
                }}
                disabled
                style={{ width: "350px" }}
              />
              <InputField
                label="Total Cheque/DD Amount (Different Bank)"
                name="amount"
                required
                value={chequeAmountValueDifferentBank ?? 0}
                onChange={(event) => {
                  const { value } = event.target;
                  handleChequeAmountDiffChange(value);
                }}
                disabled
                style={{ width: "350px" }}
              />
              {/* <InputField
                label="Total DD Amount"
                name="amount"
                required
                value={ddAmountValue}
                onChange={(event) => {
                  const { value } = event.target;
                  handleDDAmountChange(value);
                }}
                disabled
                style={{ width: "350px" }}
              /> */}
            </Box>
            <Box
              sx={{
                display: "flex",
                padding: "12px 24px",
                alignItems: "center",
                gap: "146px",
                alignSelf: "stretch",
              }}
            >
              {/* <InputField
                label="DD Total"
                name="amount"
                required
                value={ddTotal ?? 0}
                onChange={(event) => {
                  const { value } = event.target;
                  handleDDAmountChange(value);
                }}
                disabled
                style={{ width: "350px" }}
              /> */}
              <InputField
                label="Total"
                name="amount"
                required
                value={total ?? 0}
                onChange={(event) => {
                  const { value } = event.target;
                  handleTotalAmount(value);
                }}
                disabled
                style={{ width: "350px" }}
              />
            </Box>
            <Box sx={{ paddingLeft: "24px" }}>
              <Typography sx={{ color: "Red" }}>
                <span style={{ fontWeight: "bold" }}>Member ID</span> should
                belong to a member from the same chapter only.
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                padding: "12px 24px",
                alignItems: "center",
                gap: "146px",
                alignSelf: "stretch",
              }}
            >
              <Autocomplete
                options={members}
                getOptionLabel={(option) =>
                  `${option.id} - (${option.fullName})`
                }
                value={selectedMember}
                onChange={(event, newValue) => {
                  setSelectedMember(newValue);
                  if (newValue) {
                    setMemberId(`${newValue.id} - (${newValue.fullName})`);
                  }
                }}
                inputValue={memberId}
                onInputChange={(event, newInputValue) => {
                  setMemberId(newInputValue);
                }}
                renderInput={(params) => (
                  <InputField
                    {...params}
                    label="Member Id (Deposited by)"
                    InputLabelProps={{
                      shrink: !!memberId,
                      sx: {
                        fontSize: "14px",
                        transform: "translate(16px, 11px) scale(1)",
                        "&.MuiInputLabel-shrink": {
                          transform: "translate(16px, -9px) scale(0.75)",
                        },
                      },
                    }}
                  />
                )}
                style={{
                  width: 350,
                }}
              />
              <BasicDatePicker
                label="Deposit Date"
                sx={{
                  width: "350px",
                  backgroundColor: "white",
                }}
                onChange={handleDepositDateChange}
                value={selectedDepositDate}
                required
              />
            </Box>
            {/* <Box
              sx={{
                display: "flex",
                padding: "12px 24px",
                alignItems: "center",
                gap: "146px",
                alignSelf: "stretch",
              }}
            >
              <BasicDatePicker
                label="Date From"
                sx={{
                  width: "350px",
                  backgroundColor: "white",
                }}
                onChange={handleFromDateChange}
                value={selectedFromDate}
                required
              />
              <BasicDatePicker
                label="Date To"
                sx={{
                  width: "350px",
                  backgroundColor: "white",
                }}
                onChange={handleToDateChange}
                value={selectedToDate}
                required
              />
            </Box> */}
            <Box
              sx={{
                display: "flex",
                // padding: "24px 30px",
                padding: "24px 30px 0px 30px",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "24px",
                alignSelf: "stretch",
              }}
            >
              <Button cancel onClick={resetForm}>
                Cancel
              </Button>
              <Button onClick={handleSubmit}>Submit</Button>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                // gap: "10px",
                // alignItems: "center",
                paddingLeft: "24px",
                paddingTop: "10px",
                paddingBottom: "24px",
              }}
            >
              <Typography sx={{ color: "Red" }}>
                There are 3 icons next to the Deposit summary.
              </Typography>
              <Typography sx={{ color: "Red" }}>
                1. <span style={{ fontWeight: "bold" }}>View Details</span> -
                Shows summary of the contribution
              </Typography>
              <Typography sx={{ color: "Red" }}>
                2.{" "}
                <span style={{ fontWeight: "bold" }}>Upload Deposit Slips</span>{" "}
                - Cash/ Cheques (Same Bank) / Cheques (Different Bank)
              </Typography>
              <Typography sx={{ color: "Red" }}>
                3.{" "}
                <span style={{ fontWeight: "bold" }}>
                  Download or View Deposit Slips{" "}
                </span>
                {/* - Download or View Cash/ Cheques (Same Bank) / Cheques
                (Different Bank) */}
              </Typography>
            </Box>
          </Box>
        )}
        {profileData?.assignedRoles?.includes("contributionAdmin") && (
<Box
  sx={{
    border: "1px solid #ddd",
    borderRadius: "8px",
    padding: "20px",
    minWidth: 413,
  }}
>
  {/* 🔹 Top Row: Heading (left) + Reset (right) */}
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "20px",
    }}
  >
    <h3 style={{ margin: 0 }}>Organization Structure</h3>
    <Button cancel onClick={removeFilter}>
      Reset
    </Button>
  </Box>

  {/* 🔹 Middle: Form */}
  <OrganizationStructureForAdmin
    clearValues={clearContributions}
    setNameValues={setOrgNames}
    onUpdateValues={updateOrganizationStructureValuesAdmin}
  />

  {/* 🔹 Bottom: Search button aligned right */}
  <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
    <Button onClick={getBankDetailsForAdmin}>Search</Button>
  </Box>
</Box>

        )}
        {profileData?.assignedRoles?.includes("contributionAdmin") &&
          searchPerformed && (
            <div style={styles.filterWrapper}>
              <div style={styles.filterContainer}>
                {appliedFilters.map((filter, index) => (
                  <>{filter}</>
                ))}
              </div>
            </div>
          )}
        {tableData.length > 0 ? (
          <Box sx={{ marginBottom: "24px" }}>
            <NewTable
              columns={BANK_DEPOSIT_DETAILS_COL}
              rows={getRows(tableData)}
              tableBodyTheme="#E8F6FC"
            />
            <Pagination
              pageCount={pageCount}
              onPageChange={handleChangePage}
              forcePage={currentPage}
            />
          </Box>
        ) : (
          <NodataText>No existing data found.</NodataText>
        )}
      </OuterContainerStyles>
      <UploadReceiptModal
        open={updateModalOpen}
        onClose={handleUpdateModal}
        uploadId={uploadId}
        getBankDetails={getBankDetails}
      />
      <EditBankDepositModal
        open={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        editId={editId}
        fromDate={fromDate}
        toDate={toDate}
        getBankDetails={getBankDetails}
      />
      <DownloadReceiptModal
        open={downloadModalOpen}
        onClose={handleDownloadModal}
        uploadId={uploadId}
      />
      {isLoading && <Loader />}
    </div>
  );
}
const NodataText = styled.p`
  color: #e41717;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
`;

export default BankDepositDetails;
